import { Line, Text } from "@react-three/drei";
import React from "react";
import { SERIF } from "../../../../constants";
import shallow from "zustand/shallow";
import calcRelativePaddings from "../../../../store/helpers/calcRelativePaddings";
import { DecorDimensionsProps } from "../types";
import { useStoreRoom } from "../../../../store";

const DecorWallDimensions: React.FC<DecorDimensionsProps> = (props) => {
    const { decor, visible } = props;

    const room = useStoreRoom(
        (state) => ({
            roomLength: state.length,
            roomHeight: state.height,
            roomDepth: state.depth,
        }),
        shallow
    );

    const paddingsPayload = calcRelativePaddings(decor, room);

    if (!visible) return null;

    const z = 0.1;

    const indent = 0.05;

    const boundingY = decor.height * decor.center[1];

    const yTopStart = decor.height * decor.center[1] + indent;
    const yTopEnd = paddingsPayload.top / 1000 + boundingY - indent;
    const yTopMiddle = decor.height * decor.center[1] + paddingsPayload.top / 2000;

    const yBottomStart = -boundingY - indent;
    const yBottomEnd = -(paddingsPayload.bottom / 1000 + boundingY - indent);
    const yBottomMiddle = -(decor.height * decor.center[1] + paddingsPayload.bottom / 2000);

    const boundingX = decor.width * decor.center[0];

    const xLeftStart = -boundingX - indent;
    const xLeftEnd = -(paddingsPayload.left / 1000 + boundingX - indent);
    const xLeftMiddle = -(decor.width * decor.center[0] + paddingsPayload.left / 2000);

    const xRightStart = boundingX + indent;
    const xRightEnd = paddingsPayload.right / 1000 + boundingX - indent;
    const xRightMiddle = decor.width * decor.center[0] + paddingsPayload.right / 2000;

    return (
        <group>
            <group
                rotation={[decor.rotation.x, decor.rotation.y, decor.rotation.z]}
                position={[decor.position[0], decor.position[1], decor.position[2]]}
            >
                <Line
                    points={[
                        [-SERIF, yTopStart, z],
                        [SERIF, yTopStart, z],
                    ]}
                    lineWidth={1}
                    color="#EB3D00"
                />
                <Line
                    points={[
                        [-SERIF, yTopEnd, z],
                        [SERIF, yTopEnd, z],
                    ]}
                    lineWidth={1}
                    color="#EB3D00"
                />
                <Line
                    points={[
                        [0, yTopStart, z],
                        [0, yTopEnd, z],
                    ]}
                    lineWidth={0.5}
                    color="#EB3D00"
                />
                <Text color="white" anchorX="center" anchorY="middle" position={[0.15, yTopMiddle, z]}>
                    {paddingsPayload.top}
                </Text>
            </group>
            <group
                rotation={[decor.rotation.x, decor.rotation.y, decor.rotation.z]}
                position={[decor.position[0], decor.position[1], decor.position[2]]}
            >
                <Line
                    points={[
                        [-SERIF, yBottomStart, z],
                        [SERIF, yBottomStart, z],
                    ]}
                    lineWidth={1}
                    color="#EB3D00"
                />
                <Line
                    points={[
                        [-SERIF, yBottomEnd, z],
                        [SERIF, yBottomEnd, z],
                    ]}
                    lineWidth={1}
                    color="#EB3D00"
                />
                <Line
                    points={[
                        [0, yBottomStart, z],
                        [0, yBottomEnd, z],
                    ]}
                    lineWidth={0.5}
                    color="#EB3D00"
                />
                <Text color="white" anchorX="center" anchorY="middle" position={[0.15, yBottomMiddle, z]}>
                    {paddingsPayload.bottom}
                </Text>
            </group>
            <group
                rotation={[decor.rotation.x, decor.rotation.y, decor.rotation.z]}
                position={[decor.position[0], decor.position[1], decor.position[2]]}
            >
                <Line
                    points={[
                        [xLeftStart, -SERIF, z],
                        [xLeftStart, SERIF, z],
                    ]}
                    lineWidth={1}
                    color="#EB3D00"
                />
                <Line
                    points={[
                        [xLeftEnd, -SERIF, z],
                        [xLeftEnd, SERIF, z],
                    ]}
                    lineWidth={1}
                    color="#EB3D00"
                />
                <Line
                    points={[
                        [xLeftStart, 0, z],
                        [xLeftEnd, 0, z],
                    ]}
                    lineWidth={0.5}
                    color="#EB3D00"
                />
                <Text color="white" anchorX="center" anchorY="middle" position={[xLeftMiddle, 0.15, z]}>
                    {paddingsPayload.left}
                </Text>
            </group>
            <group
                rotation={[decor.rotation.x, decor.rotation.y, decor.rotation.z]}
                position={[decor.position[0], decor.position[1], decor.position[2]]}
            >
                <Line
                    points={[
                        [xRightStart, -SERIF, z],
                        [xRightStart, SERIF, z],
                    ]}
                    lineWidth={1}
                    color="#EB3D00"
                />
                <Line
                    points={[
                        [xRightEnd, -SERIF, z],
                        [xRightEnd, SERIF, z],
                    ]}
                    lineWidth={1}
                    color="#EB3D00"
                />
                <Line
                    points={[
                        [xRightStart, 0, z],
                        [xRightEnd, 0, z],
                    ]}
                    lineWidth={0.5}
                    color="#EB3D00"
                />
                <Text color="white" anchorX="center" anchorY="middle" position={[xRightMiddle, 0.15, z]}>
                    {paddingsPayload.right}
                </Text>
            </group>
        </group>
    );
};

export default DecorWallDimensions;
